<template>
  <div class="box">
    <!--导航栏 start-->
    <van-nav-bar left-text="返回" fixed title="商户信息" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <!--导航栏   @submit="onSubmit"end-->
    <van-form style="background-color: white">
      <van-divider
        content-position="left"
        :style="{
          color: '#1989fa',
          borderColor: '#1989fa',
          margin: '0.4rem 0 0 -1.1rem',
        }"
      >商户信息</van-divider>
      <!-- 选择结算类型 -->
      <van-field
        readonly
        clickable
        required
        name="settlement_period"
        :rules="[{ required: true, message: '结算类型必选' }]"
        :value="settlement_period_text"
        label="结算类型"
        placeholder="点击选择结算类型"
        @click="settlement_period_show_picker = true"
      />
      <van-popup v-model="settlement_period_show_picker" position="bottom">
        <van-picker
          show-toolbar
          :columns="settlement_period_columns"
          @confirm="onSettlementPeriodConfirm"
          @cancel="settlement_period_show_picker = false"
        />
      </van-popup>
      <!--  -->
      <!-- 易生地区吗 -->
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        label="地区"
        placeholder="请选择所在地区"
        @click="show = true"
        required
        :rules="[{ required: true, message: '省区县必选' }]"
      />
      <van-popup v-model="show" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="options"
          @close="show = false"
          @finish="onFinish"
        />
      </van-popup>
      <!--商户类型 start-->
      <van-field name="merchant_type" label="商户类型" required>
        <template #input>
          <van-radio-group
            icon-size="0.4rem"
            v-model="form.merchant_type"
            direction="horizontal"
            @change="changeRadio"
          >
            <van-radio :name="3">小微</van-radio>
            <van-radio :name="1">个体</van-radio>
            <van-radio :name="2">企业</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!--商户类型 end-->
      <!--商户名称 start-->
      <van-field
        name="store_name"
        v-model="form.store_name"
        label="商户名称"
        placeholder="请输入商户名称"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '请输入商户名称' }]"
      />
      <!--商户名称 end-->
      <!--商户名称 start-->
      <van-field
        readonly
        clickable
        required
        name="provinceCode_cityCode_areaCode"
        :rules="[{ required: true, message: '省区县必选' }]"
        :value="provinceCode_cityCode_areaCode"
        label="地区码"
        placeholder="点击选择地区"
        @click="show_address_picker = true"
      />
      <van-popup v-model="show_address_picker" position="bottom">
        <van-area
          :area-list="leshuazf_area"
          @confirm="onAddressConfirm"
          @cancel="show_address_picker = false"
          :columns-num="3"
          title="省区县"
        />
      </van-popup>
      <van-field
        v-model="form.merchant_address"
        name="merchant_address"
        required
        label="商户地址"
        :rules="[{ required: true, message: '商户地址必须填写' }]"
        placeholder="商户地址需超过5个字，详细到门牌号"
      />
      <!--商户名称 end-->
      <!--商户经营名称 v-if="form.merchant_type != 3" start-->
      <!-- <van-field
        name="bse_lice_nm"
        v-model="form.bse_lice_nm"
        label="商户经营名称"
        placeholder="请输入商户经营名称,个体或企业填写营业执照名称"
        maxlength="150"
        rows="1"
        show-word-limit
        required
        clearable
        clickable
        :rules="[{ required: true, message: '与营业执照上登记注册的名称一致' }]"
      />-->
      <!--商户经营名称 end-->

      <!--联系人 start-->
      <van-field
        name="store_contacts"
        v-model="form.store_contacts"
        label="联系人"
        placeholder="请输入联系人"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '请输入联系人' }]"
      />
      <!--联系人 end-->

      <!--联系电话 start-->
      <van-field
        name="store_tel"
        v-model="form.store_tel"
        label="联系电话"
        placeholder="请输入联系电话"
        required
        clearable
        clickable
        :rules="[
          { required: true, message: '联系电话必须填写' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },
        ]"
      />
      <!-- mcc码 -->
      <van-field
        readonly
        clickable
        required
        name="merchant_mcc"
        :rules="[{ required: true, message: 'mcc码必选' }]"
        :value="merchant_mcc"
        label="mcc码"
        placeholder="点击mcc码"
        @click="merchant_mcc_picker = true"
      />
      <van-popup v-model="merchant_mcc_picker" position="bottom">
        <van-picker
          show-toolbar
          :columns="MCC_ARR"
          @confirm="merchantMccConfirm"
          @cancel="merchant_mcc_picker = false"
        />
      </van-popup>
      <!-- 行业大类 -->
      <!-- <van-field
        readonly
        clickable
        required
        name="standard_flag"
        :rules="[{ required: true, message: '行业大类必选' }]"
        :value="standard_flag"
        label="行业大类"
        placeholder="点击选择行业大类"
        @click="standard_flag_picker = true"
      />
      <van-popup v-model="standard_flag_picker" position="bottom">
        <van-picker
          show-toolbar
          :columns="standardFlag"
          @confirm="standardFlagConfirm"
          @cancel="standard_flag_picker = false"
        />
      </van-popup>-->
      <!-- 公司规模 -->
      <van-field
        readonly
        clickable
        required
        name="employee_num"
        :rules="[{ required: true, message: '公司规模必选' }]"
        :value="employee_num"
        label="公司规模"
        placeholder="点击选择公司规模"
        @click="employee_num_picker = true"
      />
      <van-popup v-model="employee_num_picker" position="bottom">
        <van-picker
          show-toolbar
          :columns="employeeNum"
          @confirm="employeeNumConfirm"
          @cancel="employee_num_picker = false"
        />
      </van-popup>

      <!--身份证失效日期 end-->
      <van-divider
        content-position="left"
        :style="{
          color: '#1989fa',
          borderColor: '#1989fa',
          margin: '0.4rem 0 0 -1.1rem',
        }"
      >法人信息</van-divider>
      <!--法人身份证正面 ok start-->
      <van-field
        v-model="form.merchant_img_corporate_id_card_front"
        name="merchant_img_corporate_id_card_front"
        :rules="[{ required: true, message: '法人身份证正面必须上传' }]"
        label="法人身份证正面"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_corporate_id_card_front"
            v-model="file_img.merchant_img_corporate_id_card_front"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--法人身份证正面 end-->

      <!--法人身份证反面 ok start-->
      <van-field
        v-model="form.merchant_img_corporate_id_card_obverse"
        name="merchant_img_corporate_id_card_obverse"
        :rules="[{ required: true, message: '法人身份证反面必须上传' }]"
        label="法人身份证反面"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_corporate_id_card_obverse"
            v-model="file_img.merchant_img_corporate_id_card_obverse"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--法人身份证反面 end-->

      <!--法人姓名 start-->
      <van-field
        name="crp_nm"
        v-model="form.crp_nm"
        label="法人姓名"
        placeholder="请输入法人姓名"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '法人姓名必须填写' }]"
      />
      <!--法人姓名 end-->
      <!--法人手机号 start-->
      <van-field
        name="crp_mobile"
        v-model="form.crp_mobile"
        label="法人手机号"
        placeholder="请输入法人手机号"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '法人手机号必须填写' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }]"
      />
      <!--法人手机号 end-->

      <!--法人证件号 start-->
      <van-field
        name="crp_id"
        v-model="form.crp_id"
        label="法人证件号"
        placeholder="请输入法人证件号"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '法人证件号必须填写' }]"
      />
      <!--法人证件号 end-->
      <!--法人地址 start-->
      <van-field
        name="merchant_img_corporate_id_card_address"
        v-model="form.merchant_img_corporate_id_card_address"
        label="法人身份证地址"
        placeholder="请输入法人身份证地址"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '法人身份证地址必须填写' }]"
      />
      <!--法人地址 end-->

      <!--法人身份证开始日期 start-->
      <van-field
        readonly
        required
        clickable
        name="crp_start_dt"
        :value="form.crp_start_dt"
        label="法人身份证开始日期"
        placeholder="点击选择时间"
        @click="crp_start_dt_show_picker = true"
        :rules="[{ required: true, message: '法人身份证开始日期必须填写' }]"
      />
      <van-popup v-model="crp_start_dt_show_picker" position="bottom">
        <van-datetime-picker
          :min-date="crp_start_dt_min_date"
          :max-date="crp_start_dt_max_date"
          type="date"
          @confirm="onCrpStartDtConfirm"
          @cancel="crp_start_dt_show_picker = false"
        />
      </van-popup>
      <!--法人身份证开始日期 end-->

      <!--法人身份证结束日期 start-->
      <van-row style="background: #fff">
        <van-col span="18">
          <van-field
            readonly
            required
            clickable
            name="crp_exp_dt"
            :value="form.crp_exp_dt"
            label="法人身份证结束日期"
            placeholder="点击选择时间"
            @click="crp_exp_dt_show_click"
            :rules="[{ required: true, message: '法人身份证结束日期必须填写' }]"
          />
          <van-popup v-model="crp_exp_dt_show_picker" position="bottom">
            <van-datetime-picker
              :min-date="crp_start_dt_min_date"
              :max-date="crp_start_dt_max_date"
              type="date"
              @confirm="onCrpExpDtConfirm"
              @cancel="crp_exp_dt_show_picker = false"
            />
          </van-popup>
        </van-col>
        <van-col span="6" style="padding-top: 0.6rem">
          <van-checkbox v-model="isCrpExpDt" class="checkbox_text">长期</van-checkbox>
        </van-col>
      </van-row>
      <!-- v-show="form.merchant_type != '3'" -->
      <div >
        <van-divider
          content-position="left"
          :style="{
            color: '#1989fa',
            borderColor: '#1989fa',
            margin: '0.4rem 0 0 -1.1rem',
          }"
        >营业执照信息</van-divider>
        <!--营业执照 ok start v-if="form.merchant_type == 1 || form.merchant_type==2 "    [{ required: true, message: '营业执照必须上传' }]-->
        <van-field
          v-model="form.merchant_img_electronic_business_license"
          name="merchant_img_electronic_business_license"
          :rules="rules_merchant_img_electronic_business_license"
          required
          label="营业执照"
          v-show="form.merchant_type != '3'"
        >
          <template #input>
            <van-uploader
              name="merchant_img_electronic_business_license"
              v-model="file_img.merchant_img_electronic_business_license"
              multiple
              :max-count="1"
              :after-read="afterRead"
            />
          </template>
        </van-field>
        <!--营业执照 end-->
        <!--营业执照名称 start-->
        <van-field
          name="bse_lice_nm"
          v-model="form.bse_lice_nm"
          label="经营执照名称"
          placeholder="请输入商户经营名称,个体或企业填写营业执照名称"
          maxlength="150"
          rows="1"
          show-word-limit
          required
          clearable
          clickable
          :rules="rules_bse_lice_nm"
           v-show="form.merchant_type != '3'"
        />
        <!--营业执照名称 end-->
        <!--营业执照号 start  v-if="form.merchant_type == 1 || form.merchant_type==2"-->
        <van-field
          name="bus_lic_no"
          v-model="form.bus_lic_no"
          label="营业执照号"
          placeholder="请输入营业执照号"
          required
          clearable
          clickable
          :rules="rules_bus_lic_no"
           v-show="form.merchant_type != '3'"
        />
        <!--营业执照号 end-->
        <!--营业执照生效日期  v-if="form.merchant_type == 1 || form.merchant_type==2" start-->
        <van-field
          readonly
          required
          clickable
          name="bus_start_dt"
          :value="form.bus_start_dt"
          label="营业执照生效日期"
          placeholder="点击选择时间"
          @click="bus_start_dt_show_picker = true"
          :rules="rules_bus_start_dt"
          v-show="form.merchant_type != '3'"
        />
        <van-popup v-model="bus_start_dt_show_picker" position="bottom">
          <van-datetime-picker
            :min-date="crp_start_dt_min_date"
            :max-date="crp_start_dt_max_date"
            type="date"
            @confirm="onBusStartDtConfirm"
            @cancel="bus_start_dt_show_picker = false"
          />
        </van-popup>
        <!--营业执照生效日期 end-->
        <!--营业执照失效日期 start v-if="form.merchant_type == 1 || form.merchant_type==2"-->
        <van-row style="background: #fff" v-show="form.merchant_type != '3'">
              
          <van-col span="18" >
            <van-field
              readonly
              required
              clickable
              name="bus_exp_dt"
              :value="form.bus_exp_dt"
              label="营业执照失效日期"
              placeholder="点击选择时间"
              @click="bus_exp_dt_show_click"
              :rules="rules_bus_exp_dt"
            />
            <van-popup v-model="bus_exp_dt_show_picker" position="bottom">
              <van-datetime-picker
                :min-date="crp_start_dt_min_date"
                :max-date="crp_start_dt_max_date"
                type="date"
                @confirm="onBusExpDtConfirm"
                @cancel="bus_exp_dt_show_picker = false"
              />
            </van-popup>
          </van-col>
          <van-col span="6" style="padding-top: 0.6rem">
            <van-checkbox v-model="isBusExpDt" class="checkbox_text">长期</van-checkbox>
          </van-col>
        </van-row>
        <!--营业执照失效日期 end-->

        <!--营业执照地址 start  v-if="form.merchant_type == 1 || form.merchant_type==2"-->
        <van-field
          name="bus_lic_address"
          v-model="form.bus_lic_address"
          label="营业执照地址"
          placeholder="请输入营业执照地址"
          required
          clearable
          clickable
          :rules="rules_bus_lic_address"
        />
        <!--营业执照地址 end-->

        <!-- 主营业务 -->
        <van-field
          name="busin_scope"
          v-model="form.busin_scope"
          label="主营业务"
          placeholder="请输入主营业务"
          required
          clearable
          clickable
          :rules="[
          { required: true, message: '主营业务必须填写' },
        ]"
        />
        <!-- 主营业务 -->
        <!-- 注册资本 -->
        <van-field
          name="capital"
          v-model="form.capital"
          label="注册资本:万"
          placeholder="请输入注册资本"
          required
          clearable
          clickable
          :rules="[
          { required: true, message: '注册资本必须填写' },
        ]"
        />
        <!-- 注册资本 -->
        <!-- 控股人姓名 -->
        <van-field
          name="controler_name"
          v-model="form.controler_name"
          label="控股人姓名"
          placeholder="请输入控股人姓名"
          required
          clearable
          clickable
          :rules="[
          { required: true, message: '控股人姓名必须填写' },
        ]"
        />
        <!-- 控股人姓名 -->
        <!-- 身份证号 -->
        <van-field
          name="controler_legal_code"
          v-model="form.controler_legal_code"
          label="身份证号"
          placeholder="请输入身份证号"
          required
          clearable
          clickable
          :rules="[
          { required: true, message: '身份证号必须填写' },
        ]"
        />
        <!-- 身份证号 -->
        <!--身份证生效日期  v-if="form.merchant_type == 1 || form.merchant_type==2" start-->
        <van-field
          readonly
          required
          clickable
          name="controler_legal_validity_st"
          :value="form.controler_legal_validity_st"
          label="身份证生效日期"
          placeholder="点击选择时间"
          @click="controler_legal_validity_st_show_picker = true"
          :rules="rules_controler_legal_validity_st"
        />
        <van-popup v-model="controler_legal_validity_st_show_picker" position="bottom">
          <van-datetime-picker
            :min-date="crp_start_dt_min_date"
            :max-date="crp_start_dt_max_date"
            type="date"
            @confirm="onControlerLegalConfirm"
            @cancel="controler_legal_validity_st_show_picker = false"
          />
        </van-popup>
        <!--身份证生效日期 end-->
        <!--身份证失效日期 start v-if="form.merchant_type == 1 || form.merchant_type==2"-->
        <van-row style="background: #fff">
          <van-col span="18">
            <van-field
              readonly
              required
              clickable
              name="controler_legal_validity_en"
              :value="form.controler_legal_validity_en"
              label="身份证失效日期"
              placeholder="点击选择时间"
              @click="controler_legal_validity_en_show_click"
              :rules="rules_controler_legal_validity_en"
            />
            <van-popup v-model="controler_legal_validity_en_show_picker" position="bottom">
              <van-datetime-picker
                :min-date="crp_start_dt_min_date"
                :max-date="crp_start_dt_max_date"
                type="date"
                @confirm="onControlerEnConfirm"
                @cancel="controler_legal_validity_en_show_picker = false"
              />
            </van-popup>
          </van-col>
          <van-col span="6" style="padding-top: 0.6rem">
            <van-checkbox v-model="isControlerEn" class="checkbox_text">长期</van-checkbox>
          </van-col>
        </van-row>
      </div>
      <!--法人身份证结束日期 end-->
      <van-divider
        content-position="left"
        :style="{
          color: '#1989fa',
          borderColor: '#1989fa',
          margin: '0.4rem 0 0 -1.1rem',
        }"
      >结算信息</van-divider>
      <!--结算卡类型 00:对公账户 01:法人账户02：被授权人账户 start-->
      <van-field
        readonly
        clickable
        required
        name="settlement_account_type"
        :rules="[{ required: true, message: '结算卡类型必选' }]"
        :value="settlement_account_type_text"
        label="结算卡类型"
        placeholder="点击选择结算卡类型"
        @click="settlement_account_type_show_picker = true"
        v-if="form.merchant_type != 3"
      />
      <van-field
        readonly
        clickable
        required
        name="settlement_account_type"
        :rules="[{ required: true, message: '结算卡类型必选' }]"
        :value="settlement_account_type_text"
        label="结算卡类型"
        placeholder="点击选择结算卡类型"
        @click="settlement_account_type_show_picker = true"
        disabled
        v-else
      />
      <van-popup v-model="settlement_account_type_show_picker" position="bottom">
        <van-picker
          show-toolbar
          :columns="settlement_account_type_columns"
          @confirm="onSettlementAccountTypeConfirm"
          @cancel="settlement_account_type_show_picker = false"
        />
      </van-popup>
      <!--结算卡类型 end-->
      <!--开户许可证 ok start -->
      <!-- form.merchant_type -->
      <!-- v-if="form.settlement_account_type == '00'" -->

      <van-field
         v-show="form.merchant_type == '2' || form.settlement_account_type == '00'"
        v-model="form.merchant_img_permit_for_bank_account"
        name="merchant_img_permit_for_bank_account"
        :rules="rules_merchant_img_permit_for_bank_account"
        label="开户许可证"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_permit_for_bank_account"
            v-model="file_img.merchant_img_permit_for_bank_account"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--开户许可证 end-->
      <!--银行卡正面 ok start  -->
      <van-field
        v-show="form.settlement_account_type != '00'"
        v-model="form.merchant_img_bank_card"
        name="merchant_img_bank_card"
        :rules="rules_merchant_img_bank_card"
        label="银行卡正面"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_bank_card"
            v-model="file_img.merchant_img_bank_card"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--银行卡正面 end-->

      <!--银行卡反面 ok start -->
      <van-field
        v-show="form.settlement_account_type != '00'"
        v-model="form.merchant_img_bank_card_back"
        name="merchant_img_bank_card_back"
        :rules="rules_merchant_img_bank_card_back"
        label="银行卡反面"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_bank_card_back"
            v-model="file_img.merchant_img_bank_card_back"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--银行卡反面 end-->

      <!--结算授权书 ok start     v-if="form.settlement_account_type=='02'"-->
      <van-field
         v-show="form.settlement_account_type != '00'"
        v-model="form.merchant_img_authorization_statement"
        name="merchant_img_authorization_statement"
        :rules="rules_merchant_img_authorization_statement"
        label="结算授权书"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_authorization_statement"
            v-model="file_img.merchant_img_authorization_statement"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--结算授权书 end-->

      <!--账户名 start-->
      <van-field
        name="settlement_account_name"
        v-model="form.settlement_account_name"
        label="账户名"
        placeholder="请输入账户名"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '账户户名必须填写' }]"
      />
      <!--账户名 end-->
      <!--开户账号 start-->
      <van-field
        name="settlement_card_number"
        v-model="form.settlement_card_number"
        label="开户账号"
        placeholder="请输入开户账号"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '开户账号必须填写' }]"
      />
      <!--开户账号 end-->
      <!--开户银行名称 start-->
      <van-field
        name="settlement_bank"
        v-model="form.settlement_bank"
        label="开户行"
        placeholder="请输入开户银行名称"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '开户银行名称必须填写' }]"
      />
      <!--开户银行名称 end-->
      <!--银行预留手机号 start-->
      <van-field
        name="settlement_bank_tel"
        v-model="form.settlement_bank_tel"
        label="银行预留手机号"
        placeholder="请输入银行预留手机号"
        required
        clearable
        clickable
        :rules="[
          { required: true, message: '银行预留手机号必须填写' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },
        ]"
      />
      <!--银行预留手机号 end-->
      <!--银行网点-省 start-->
      <van-field
        readonly
        clickable
        :value="provinceBanksVal"
        label="银行网点-省"
        placeholder="点击选择银行网点-省"
        @click="showProvinceBanksPicker = true"
      />
      <van-popup v-model="showProvinceBanksPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="provinceBanks"
          @confirm="onProvinceBanksConfirm"
          @cancel="showLegalFlagPicker = false"
        />
      </van-popup>
      <!--银行网点省 end-->

      <!--银行网点市 start-->
      <van-field
        readonly
        clickable
        :value="cityBanksVal"
        label="银行网点-市"
        placeholder="点击选择银行网点-市"
        @click="showCityBanksPicker = true"
      />
      <van-popup v-model="showCityBanksPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="cityBanks"
          @confirm="onCityBanksConfirm"
          @cancel="showCityBanksPicker = false"
        />
      </van-popup>
      <!--银行网点市 end-->

      <!--银行分行网点 start-->
      <van-field
        readonly
        clickable
        required
        name="settlement_open_subbank"
        :rules="[{ required: true, message: '银行分行网点必填' }]"
        :value="form.settlement_open_subbank"
        label="银行分行网点"
        placeholder="模糊搜索银行分行网点"
        @click="showBanksPicker = true"
      />
      <van-popup round v-model="showBanksPicker" position="bottom" :style="{ height: '80%' }">
        <van-search v-model="banksValue" placeholder="请输入银行关键词" />
        <van-cell
          @click="banksSelected(item)"
          clickable
          v-bind:key="key"
          v-for="(item, key) in banksData"
          :value="item.address"
        />
      </van-popup>
      <!--银行分行网点 end-->

      <div  v-show="form.settlement_account_type == '02'">
        <van-divider
          content-position="left"
          :style="{
            color: '#1989fa',
            borderColor: '#1989fa',
            margin: '0.4rem 0 0 -1.1rem',
          }"
        >结算人信息</van-divider>
        <!--结算人身份证正面 ok start-->
        <van-field
          v-model="form.merchant_img_principal_id_card_front"
          name="merchant_img_principal_id_card_front"
          :rules="rules_merchant_img_principal_id_card_front"
          label="结算人身份证正面"
          required
        >
          <template #input>
            <van-uploader
              name="merchant_img_principal_id_card_front"
              v-model="file_img.merchant_img_principal_id_card_front"
              multiple
              :max-count="1"
              :after-read="afterRead"
            />
          </template>
        </van-field>
        <!--结算人身份证正面 end-->

        <!--结算人身份证反面 ok start-->
        <van-field
          v-model="form.merchant_img_principal_id_card_obverse"
          name="merchant_img_principal_id_card_obverse"
          :rules="rules_merchant_img_principal_id_card_obverse"
          label="结算人身份证反面"
          required
        >
          <template #input>
            <van-uploader
              name="merchant_img_principal_id_card_obverse"
              v-model="file_img.merchant_img_principal_id_card_obverse"
              multiple
              :max-count="1"
              :after-read="afterRead"
            />
          </template>
        </van-field>
        <!--结算人身份证反面 end-->
        <!--结算人姓名 start-->
        <van-field
          name="s_legal_name"
          v-model="form.s_legal_name"
          label="结算人姓名"
          placeholder="请输入结算人姓名"
          required
          clearable
          clickable
          :rules="[{ required: true, message: '请输入结算人姓名' }]"
        />
        <!--结算人姓名 end-->
        <!--结算人手机号 start-->
        <van-field
          name="s_legal_phone"
          v-model="form.s_legal_phone"
          label="结算人手机号"
          placeholder="请输入结算人手机号"
          required
          clearable
          clickable
          :rules="[{ required: true, message: '请输入结算人手机号' },
           { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },]"
        />
        <!--结算人手机号 end-->

        <!--结算人证件号 start-->
        <van-field
          name="s_legal_id"
          v-model="form.s_legal_id"
          label="结算人证件号"
          placeholder="请输入结算人证件号"
          required
          clearable
          clickable
          :rules="[{ required: true, message: '请输入结算人证件号' }]"
        />
        <!--结算人证件号 end-->
        <!--结算人身份证地址 start-->
        <van-field
          name="merchant_img_principal_id_card_address"
          v-model="form.merchant_img_principal_id_card_address"
          label="结算人身份证地址"
          placeholder="请输入结算人身份证地址"
          required
          clearable
          clickable
          :rules="[{ required: true, message: '请输入结算人身份证地址' }]"
        />
        <!--结算人身份证地址 end-->
        <!--结算人身份证生效日期 start-->
        <van-field
          readonly
          required
          clickable
          name="s_legal_start_dt"
          :value="form.s_legal_start_dt"
          label="结算人身份证生效日期"
          placeholder="点击选择时间"
          @click="s_legal_start_dt_show_picker = true"
          :rules="rules_s_legal_start_dt"
        />
        <van-popup v-model="s_legal_start_dt_show_picker" position="bottom">
          <van-datetime-picker
            :min-date="crp_start_dt_min_date"
            :max-date="crp_start_dt_max_date"
            type="date"
            @confirm="onSLegalStartDtConfirm"
            @cancel="s_legal_start_dt_show_picker = false"
          />
        </van-popup>
        <!--结算人身份证生效日期 end-->
        <!--结算人身份证失效日期 start-->
        <van-row style="background: #fff">
          <van-col span="18">
            <van-field
              readonly
              required
              clickable
              name="s_legal_exp_dt"
              :value="form.s_legal_exp_dt"
              label="结算人身份证失效日期"
              placeholder="点击选择时间"
              @click="s_legal_exp_dt_show_click"
              :rules="rules_s_legal_exp_dt"
            />
            <van-popup v-model="s_legal_exp_dt_show_picker" position="bottom">
              <van-datetime-picker
                :min-date="crp_start_dt_min_date"
                :max-date="crp_start_dt_max_date"
                type="date"
                @confirm="onSLegalExpDtConfirm"
                @cancel="s_legal_exp_dt_show_picker = false"
              />
            </van-popup>
          </van-col>
          <van-col span="6" style="padding-top: 0.6rem">
            <van-checkbox v-model="isSLegalExpDt" class="checkbox_text">长期</van-checkbox>
          </van-col>
        </van-row>
        <!--结算人身份证失效日期 end-->
      </div>
      <van-divider
        content-position="left"
        :style="{
          color: '#1989fa',
          borderColor: '#1989fa',
          margin: '0.4rem 0 0 -1.1rem',
        }"
      >费率信息</van-divider>
      <!--T0终端费率 start-->
      <!-- <van-field
        @blur="rate($event,'t0')"
        name="merchant_t0_rate"
        v-model="form.merchant_t0_rate"
        type="number"
        label="T0终端费率"
        placeholder="请输入T0终端费率"
        required
        clearable
        clickable
        :rules="[
          { required: true, message: 'T0终端费率必须填写', trigger: 'blur' },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/,
            message: '需保留两位小数',
          },
        ]"
      />-->
      <!--T0终端费率 end-->
      <!--T1终端费率 start-->
      <!-- <van-field
        @blur="rate($event,'t1')"
        name="merchant_t1_rate"
        v-model="form.merchant_t1_rate"
        type="number"
        label="T1终端费率"
        placeholder="请输入T1终端费率"
        required
        clearable
        clickable
        :rules="[
          { required: true, message: 'T1终端费率必须填写', trigger: 'blur' },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/,
            message: '需保留两位小数',
          },
        ]"
      />-->
      <!--T1终端费率 end-->
      <!--D0终端费率 start-->
      <van-field
        @blur="rate($event,'d0')"
        name="merchant_d0_rate"
        v-model="form.merchant_d0_rate"
        type="number"
        label="D0终端费率"
        placeholder="请输入D0终端费率"
        required
        clearable
        clickable
        :rules="[
          { required: true, message: 'D0终端费率必须填写', trigger: 'blur' },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/,
            message: '需保留两位小数',
          },
        ]"
      />
      <!--D0终端费率 end-->
      <!--D1终端费率 start-->
      <van-field
        @blur="rate($event,'d1')"
        name="merchant_d1_rate"
        v-model="form.merchant_d1_rate"
        label="D1终端费率"
        placeholder="请输入D1终端费率"
        type="number"
        required
        clearable
        clickable
        :rules="[
          { required: true, message: 'D1终端费率必须填写', trigger: 'blur' },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/,
            message: '需保留两位小数',
          },
        ]"
      />
      <!--D1终端费率 end-->
      <!--银联小于1000费率 start-->
      <van-field
        @blur="rate($event,'unionscan')"
        name="merchant_unionscan2_rate"
        v-model="form.merchant_unionscan2_rate"
        label="银联小于1000费率"
        placeholder="请输入银联小于1000费率"
        type="number"
        required
        clearable
        clickable
        :rules="[
          {
            required: true,
            message: '银联小于1000费率必须填写',
            trigger: 'blur',
          },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/,
            message: '需保留两位小数',
          },
        ]"
      />
      <!--银联小于1000费率 end-->
      <!--银联大于1000费率 start-->
      <van-field
        @blur="rate($event,'unionscan')"
        name="merchant_unionscan_rate"
        v-model="form.merchant_unionscan_rate"
        label="银联大于1000费率"
        placeholder="请输入银联大于1000费率"
        type="number"
        required
        clearable
        clickable
        :rules="[
          {
            required: true,
            message: '银联大于1000费率必须填写',
            trigger: 'blur',
          },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/,
            message: '需保留两位小数',
          },
        ]"
      />
      <!--银联大于1000费率 end-->
      <!--银联借记卡封手续费 start-->
      <van-field
        name="merchant_union_debit_cap"
        v-model="form.merchant_union_debit_cap"
        label="银联借记卡封顶手续费"
        placeholder="请输入银联借记卡封手续费"
        required
        clearable
        clickable
        :rules="[{ required: true, message: '银联借记卡封手续费率必须填写' }]"
      />
      <!--银联借记卡封手续费 end-->
      <van-divider
        content-position="left"
        :style="{
          color: '#1989fa',
          borderColor: '#1989fa',
          margin: '0.4rem 0 0 -1.1rem',
        }"
      >门店图片信息</van-divider>
      <!--门头照1 ok start-->
      <van-field
        v-model="form.merchant_img_door_shot"
        name="merchant_img_door_shot"
        :rules="[{ required: true, message: '门头照1必须上传' }]"
        label="门店门头照1"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_door_shot"
            v-model="file_img.merchant_img_door_shot"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--门头照1 end-->

      <!--门头照2 ok start-->
      <van-field
        v-model="form.merchant_img_door_shot_2"
        name="merchant_img_door_shot_2"
        label="门店门头照2"
      >
        <template #input>
          <van-uploader
            name="merchant_img_door_shot_2"
            v-model="file_img.merchant_img_door_shot_2"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--门头照2 end-->

      <!--收银台照1 ok start-->
      <van-field
        v-model="form.merchant_img_checkout_counter"
        name="merchant_img_checkout_counter"
        :rules="[{ required: true, message: '收银台照1必须上传' }]"
        label="门店收银台照1"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_checkout_counter"
            v-model="file_img.merchant_img_checkout_counter"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--收银台照1 end-->
      <!--收银台照2 ok start-->
      <van-field
        v-model="form.merchant_img_checkout_counter_2"
        name="merchant_img_checkout_counter_2"
        label="门店收银台照2"
      >
        <template #input>
          <van-uploader
            name="merchant_img_checkout_counter_2"
            v-model="file_img.merchant_img_checkout_counter_2"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--收银台照2 end-->
      <!--店内景1 ok start-->
      <van-field
        v-model="form.merchant_img_shop_interior"
        name="merchant_img_shop_interior"
        :rules="[{ required: true, message: '店内景必须上传' }]"
        label="门店店内景照1"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_shop_interior"
            v-model="file_img.merchant_img_shop_interior"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--店内景1 end-->

      <!--店内景2 ok start-->
      <van-field
        v-model="form.merchant_img_shop_interior_2"
        name="merchant_img_shop_interior_2"
        label="门店店内景2"
      >
        <template #input>
          <van-uploader
            name="merchant_img_shop_interior_2"
            v-model="file_img.merchant_img_shop_interior_2"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--店内景2 end-->

      <!--店内景3 ok start-->
      <van-field
        v-model="form.merchant_img_shop_interior_3"
        name="merchant_img_shop_interior_3"
        label="门店店内景照3"
      >
        <template #input>
          <van-uploader
            name="merchant_img_shop_interior_3"
            v-model="file_img.merchant_img_shop_interior_3"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--店内景3 end-->
      <!--门店外景照 ok sta
      rt-->
      <van-field
        v-model="form.merchant_img_store_photo"
        name="merchant_img_store_photo"
        :rules="[{ required: true, message: '门店外景照必须上传' }]"
        label="门店外景照"
        required
      >
        <template #input>
          <van-uploader
            name="merchant_img_store_photo"
            v-model="file_img.merchant_img_store_photo"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--门店外景照 end-->
      <!--定位照 ok sta
      rt-->
      <van-field
        v-model="form.location_pic"
        name="location_pic"
        :rules="[{ required: true, message: '定位照必须上传' }]"
        label="定位照"
        required
      >
        <template #input>
          <van-uploader
            name="location_pic"
            v-model="file_img.location_pic"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--定位照 end-->
      <!--收银台内手持身份证照片 ok sta
      rt-->
      <van-field
        v-model="form.cash_hold_pic"
        name="cash_hold_pic"
        :rules="[{ required: true, message: '收银台内手持身份证照片必须上传' }]"
        label="收银台内手持身份证照片"
        required
      >
        <template #input>
          <van-uploader
            name="cash_hold_pic"
            v-model="file_img.cash_hold_pic"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--收银台内手持身份证照片 end-->

      <!--租赁协议 ok sta
      rt-->
      <van-field
         v-show="form.merchant_type == 3"
        v-model="form.leasing_agreement"
        name="leasing_agreement"
        :rules="[{ required: true, message: '租赁协议照片必须上传' }]"
        label="租赁协议"
        required
      >
        <template #input>
          <van-uploader
            name="leasing_agreement"
            v-model="file_img.leasing_agreement"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>
      <!--租赁协议 end-->

      <!--商户信息表 ok start-->
      <!-- <van-field
        v-model="form.merchant_img_information_form"
        name="merchant_img_information_form"
        label="商户信息表"
      >
        <template #input>
          <van-uploader
            name="merchant_img_information_form"
            v-model="file_img.merchant_img_information_form"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>-->
      <!--商户信息表 end-->

      <!--商户协议照 ok start-->
      <!-- <van-field v-model="form.merchant_img_agreement" name="merchant_img_agreement" label="商户协议照">
        <template #input>
          <van-uploader
            name="merchant_img_agreement"
            v-model="file_img.merchant_img_agreement"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </template>
      </van-field>-->
      <!--商户协议照 end-->

      <!-- <div v-if="form.merchant_type != '3'">
        <van-field
          v-model="form.merchant_img_legal_holding_id_photo_in_door"
          name="merchant_img_legal_holding_id_photo_in_door"
          label="法人手持营业执照门口照"
        >
          <template #input>
            <van-uploader
              name="merchant_img_legal_holding_id_photo_in_door"
              v-model="file_img.merchant_img_legal_holding_id_photo_in_door"
              multiple
              :max-count="1"
              :after-read="afterRead"
            />
          </template>
        </van-field>
      </div> -->
      <div  v-show="form.merchant_type == '2'">
        <!--门牌号 ok start-->
        <van-field
          v-model="form.merchant_img_door_number"
          name="merchant_img_door_number"
          label="门牌号"
          :rules="[{ required: true, message: '门牌号必须上传' }]"
          required
        >
          <template #input>
            <van-uploader
              name="merchant_img_door_number"
              v-model="file_img.merchant_img_door_number"
              multiple
              :max-count="1"
              :after-read="afterRead"
            />
          </template>
        </van-field>
        <!--门牌号 end-->
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { Toast, Dialog, Notify } from "vant";
import LeshuazfArea from "@/assets/json/leshuazf_area";
import easypayMcc from "@/assets/json/easypay_mcc";
import VueCookie from "vue-cookies";
import phone_upload_img from "@/assets/images/phone_upload.png";
import Config from "@/config";
import { easypayArea } from "@/assets/json/easypay_area";
let wx =
  process.env.NODE_ENV == "develepment"
    ? require("weixin-js-sdk")
    : window["wx"];
export default {
  data() {
    return {
      t0: "",
      t1: "",
      d0: "",
      d1: "",
      settlement_period_text: "",
      settlement_period_show_picker: false,
      settlement_period_columns: [
        // {
        //   text: "T0",
        //   value: "T0",
        // },
        {
          text: "T1",
          value: "T1",
        },
        {
          text: "D1",
          value: "D1",
        },
        {
          text: "D0",
          value: "D0",
        },
      ],
      // show_address_picker: false,
      fieldValue: "",
      cascaderValue: "",
      options: easypayArea,
      show: false,
      unionscan: "",
      inputValue: "",
      licensePic: "",
      provinceCode_cityCode_areaCode: "",
      show_address_picker: false,
      leshuazf_area: LeshuazfArea,
      merchant_mcc: "",
      MCC_ARR: easypayMcc,
      merchant_mcc_picker: false,
      standardFlag: [
        {
          value: "2",
          text: "减免",
        },
        {
          value: "1",
          text: "优惠",
        },
        {
          value: "0",
          text: "标准",
        },
      ],
      standard_flag: "",
      standard_flag_picker: false,
      employeeNum: [
        {
          value: "1",
          text: "0-50人",
        },
        {
          value: "2",
          text: "50-100人",
        },
        {
          value: "3",
          text: "100以上",
        },
      ],
      employee_num: "",
      employee_num_picker: false,
      bus_start_dt_show_picker: false,
      bus_exp_dt_show_picker: false,
      isBusExpDt: false,
      crp_start_dt_min_date: new Date(1970, 0, 1),
      crp_start_dt_max_date: new Date(2099, 0, 1),
      controler_legal_validity_st_show_picker: false,
      controler_legal_validity_en_show_picker: false,
      isControlerEn: false,
      crp_start_dt_show_picker: false,
      crp_exp_dt_show_picker: false,
      isCrpExpDt: false,
      settlement_account_type_text: "",
      settlement_account_type_show_picker: false,
      s_legal_start_dt_show_picker: false,
      s_legal_exp_dt_show_picker: false,
      isSLegalExpDt: false,
      banksData: [], //模糊查询银行列表数据
      provinceBanks: [], //银行网点省
      cityBanks: [], //银行网点市
      provinceBanksVal: "", //银行网点省值
      cityBanksVal: "", //银行网点市值
      settlement_open_subbank: "", //输入框银行文字
      banksValue: "", //银行名称
      showProvinceBanksPicker: false, //银行网点省
      showCityBanksPicker: false, //银行网点市
      showBanksPicker: false, //银行网点
      settlement_account_type_columns: [
        {
          text: "对公账户",
          value: "00",
        },
        {
          text: "对私法人账户",
          value: "01",
        },
        {
          text: "对私非法人账户",
          value: "02",
        },
      ],
      rules_merchant_img_electronic_business_license: [
        {
          required: true,
          message: "营业执照必须上传",
        },
      ],
      rules_bse_lice_nm: [
        {
          required: true,
          message: "与营业执照上登记注册的名称一致",
        },
      ],
      rules_bus_lic_no: [
        {
          required: true,
          message: "营业执照号必须填写",
        },
      ],
      rules_bus_lic_address: [
        {
          required: true,
          message: "营业执照地址必须填写",
        },
      ],
      rules_bus_start_dt: [
        {
          required: true,
          message: "营业执照生效日期必须填写",
        },
      ],
      rules_bus_exp_dt: [
        {
          required: true,
          message: "营业执照失效日期必须填写",
        },
      ],
      rules_controler_legal_validity_st: [
        {
          required: true,
          message: "身份证生效日期必须填写",
        },
      ],
      rules_controler_legal_validity_en: [
        {
          required: true,
          message: "身份证失效日期必须填写",
        },
      ],
      rules_merchant_img_bank_card: [
        {
          required: true,
          message: "银行卡正面必须上传",
        },
      ],
      rules_merchant_img_bank_card_back: [
        {
          required: true,
          message: "银行卡反面必须上传",
        },
      ],
      rules_merchant_img_authorization_statement: [
        {
          required: true,
          message: "非法人结算授权书必须上传",
        },
      ],
      rules_merchant_img_permit_for_bank_account: [
        {
          required: true,
          message: "开户许可证必须上传",
        },
      ],
      rules_merchant_img_principal_id_card_front: [
        {
          required: true,
          message: "结算人身份证正面必须上传",
        },
      ],
      rules_merchant_img_principal_id_card_obverse: [
        {
          required: true,
          message: "结算人身份证反面必须上传",
        },
      ],
      rules_s_legal_start_dt: [
        {
          required: true,
          message: "结算人身份证生效日期必须填写",
        },
      ],
      rules_s_legal_exp_dt: [
        {
          required: true,
          message: "法人身份证结束日期必须填写",
        },
      ],

      form: {
        merchant_type: "", //商户类型
        store_name: "", //商户名称
        bse_lice_nm: "", //营业执照名
        store_contacts: "", //联系人姓名
        store_tel: "", //联系人电话
        mcc: "", //mcc码
        standard_flag: "", //公司规模
        merchant_img_electronic_business_license: "", //营业执照
        bus_lic_no: "", //营业执照号
        bus_start_dt: "", //营业执照生效日期
        bus_exp_dt: "", //营业执照失效日期
        bus_lic_address: "", //营业执照地址
        busin_scope: "", //主营业务
        capital: "", //注册资本
        controler_name: "", //控股人姓名
        controler_legal_code: "", //控股人身份证号
        controler_legal_validity_st: "", //控股人身份证开始日期
        controler_legal_validity_en: "", //控股人身份证结束日期
        crp_nm: "", //法人姓名
        crp_id: "", //法人证件号
        crp_mobile: "", //法人手机号
        crp_start_dt: "", //法人身份证开始日期
        crp_exp_dt: "", //法人身份证结束日期
        merchant_img_corporate_id_card_address: "", //法人身份证地址
        merchant_img_corporate_id_card_front: "", //法人身份证正面照片
        merchant_img_corporate_id_card_obverse: "", //法人身份证反面
        merchant_img_bank_card: "", // 银行卡正面
        merchant_img_bank_card_back: "", //银行卡反面
        merchant_img_authorization_statement: "", //结算授权函
        merchant_img_permit_for_bank_account: "", //开户许可证
        settlement_account_name: "", //结算户名
        settlement_card_number: "", //结算账号
        settlement_account_type: "", //结算账户类型
        s_legal_start_dt: "", //结算账户身份证生效日期
        s_legal_exp_dt: "", //结算账户身份证失效日期
        settlement_bank: "", //开户银行名称
        settlement_open_subbank: "", //开户支行
        settlement_bank_tel: "", //银行预留号码
        merchant_img_principal_id_card_front: "", //结算人身份证正面
        merchant_img_principal_id_card_obverse: "", //结算人身份证反面
        s_legal_name: "", //结算人姓名
        s_legal_phone: "", //结算人手机号
        s_legal_id: "", //结算人证件号
        merchant_img_principal_id_card_address: "", //结算人身份证地址
        merchant_t0_rate: "", //T0终端费率
        merchant_t1_rate: "", //T1终端费率
        merchant_d0_rate: "", //D0终端费率
        merchant_unionscan_rate: "", //银联大于1000费率
        merchant_unionscan2_rate: "", //银联小于1000费率
        merchant_union_debit_cap: "", //封顶手续费
        merchant_d1_rate: "", //D1终端费率
        merchant_img_shop_interior: "", //室内照1
        merchant_img_shop_interior_2: "", //室内照2
        merchant_img_shop_interior_3: "", //室内照3
        merchant_img_door_shot: "", //门头照
        merchant_img_door_shot_2: "", //门头照2
        merchant_img_checkout_counter: "", //收银台1
        merchant_img_checkout_counter_2: "", //收银台2
        merchant_img_store_photo: "", //店外景
        location_pic: "", //定位照
        cash_hold_pic: "", //收银台手持身份证照片
        leasing_agreement: "", //租赁协议
        // merchant_img_legal_holding_id_photo_in_door: "", // 法人手持营业执照门口照
        merchant_img_information_form: "", //商户信息表
        merchant_img_agreement: "", //商户收单协议照片
        payCode: "", //支付码
        openid: "", //用户openid
        salesman_id: "", //业务员ID
        current_gangway: "",
        settlement_period: "",
        merchant_img_door_number: "", //门牌号
      },
      file_img: {
        merchant_img_corporate_id_card_front: [],
        merchant_img_corporate_id_card_obverse: [],
        // merchant_img_legal_holding_id_photo: [],
        // merchant_img_holding_bank_card: [],
        // merchant_img_holding_bank_card_obverse: [],
        merchant_img_electronic_business_license: [],
        merchant_img_organization: [],
        merchant_img_tax: [],
        merchant_img_permit_for_bank_account: [],
        merchant_img_information_form: [],
        merchant_img_agreement: [],
        merchant_img_authorization_statement: [],
        merchant_img_bank_card: [],
        merchant_img_bank_card_back: [],
        merchant_img_principal_id_card_front: [],
        merchant_img_principal_id_card_obverse: [],
        // merchant_img_holding_photo: [],
        merchant_img_shop_interior: [],
        merchant_img_shop_interior_2: [],
        merchant_img_shop_interior_3: [],
        merchant_img_door_shot: [],
        merchant_img_door_shot_2: [],
        merchant_img_checkout_counter: [],
        merchant_img_checkout_counter_2: [],
        merchant_img_store_photo: [],
        location_pic: [],
        cash_hold_pic: [],
        leasing_agreement: [],
        // merchant_img_legal_holding_id_photo_in_door: [],
        merchant_img_door_number: [],
      },
      img: {
        merchant_img_corporate_id_card_front: phone_upload_img,
        merchant_img_corporate_id_card_obverse: phone_upload_img,
        // merchant_img_legal_holding_id_photo: phone_upload_img,
        // merchant_img_holding_bank_card: phone_upload_img,
        // merchant_img_holding_bank_card_obverse: phone_upload_img,
        merchant_img_electronic_business_license: phone_upload_img,
        merchant_img_organization: phone_upload_img,
        merchant_img_tax: phone_upload_img,
        merchant_img_permit_for_bank_account: phone_upload_img,
        merchant_img_information_form: phone_upload_img,
        merchant_img_agreement: phone_upload_img,
        merchant_img_authorization_statement: phone_upload_img,
        merchant_img_bank_card: phone_upload_img,
        merchant_img_bank_card_back: phone_upload_img,
        merchant_img_principal_id_card_front: phone_upload_img,
        merchant_img_principal_id_card_obverse: phone_upload_img,
        // merchant_img_holding_photo: phone_upload_img,
        merchant_img_shop_interior: phone_upload_img,
        merchant_img_shop_interior_2: phone_upload_img,
        merchant_img_shop_interior_3: phone_upload_img,
        merchant_img_door_shot: phone_upload_img,
        merchant_img_door_shot_2: phone_upload_img,
        merchant_img_checkout_counter: phone_upload_img,
        merchant_img_checkout_counter_2: phone_upload_img,
        merchant_img_store_photo: phone_upload_img,
        location_pic: phone_upload_img,
        cash_hold_pic: phone_upload_img,
        leasing_agreement: phone_upload_img,
        // merchant_img_legal_holding_id_photo_in_door: phone_upload_img,
        merchant_img_door_number: phone_upload_img,
      },
    };
  },
  mounted() {
    // this.getAgentRate();
  },
  created() {
    //获取省级别银行网点信息
    this.getProvinceBanks(1);
    //微信jssdk权限
    // this.getWechatJs();
    this.industry_category_id_text = "";
    this.provinceCode_cityCode_areaCode = "";
    // this.settlement_account_type_text = "";
    this.form = {
      merchant_type: "", //商户类型
      store_name: "", //商户名称
      bse_lice_nm: "", //营业执照名
      store_contacts: "", //联系人姓名
      store_tel: "", //联系人电话
      mcc: "", //mcc码
      standard_flag: "", //公司规模
      merchant_img_electronic_business_license: "", //营业执照
      bus_lic_no: "", //营业执照号
      bus_start_dt: "", //营业执照生效日期
      bus_exp_dt: "", //营业执照失效日期
      bus_lic_address: "", //营业执照地址
      busin_scope: "", //主营业务
      capital: "", //注册资本
      controler_name: "", //控股人姓名
      controler_legal_code: "", //控股人身份证号
      controler_legal_validity_st: "", //控股人身份证开始日期
      controler_legal_validity_en: "", //控股人身份证结束日期
      crp_nm: "", //法人姓名
      crp_id: "", //法人证件号
      crp_mobile: "", //法人手机号
      merchant_img_corporate_id_card_address: "", //法人身份证地址
      crp_start_dt: "", //法人身份证开始日期
      crp_exp_dt: "", //法人身份证结束日期
      merchant_img_corporate_id_card_front: "", //法人身份证正面照片
      merchant_img_corporate_id_card_obverse: "", //法人身份证反面
      merchant_img_bank_card: "", // 银行卡正面
      merchant_img_bank_card_back: "", //银行卡反面
      merchant_img_authorization_statement: "", //结算授权函
      merchant_img_permit_for_bank_account: "", //开户许可证
      settlement_account_name: "", //结算户名
      settlement_card_number: "", //结算账号
      settlement_account_type: "", //结算账户类型
      s_legal_start_dt: "", //结算账户身份证生效日期
      s_legal_exp_dt: "", //结算账户身份证失效日期
      settlement_bank: "", //开户银行名称
      settlement_open_subbank: "", //开户支行
      settlement_bank_tel: "", //银行预留号码
      merchant_img_principal_id_card_front: "", //结算人身份证正面
      merchant_img_principal_id_card_obverse: "", //结算人身份证反面
      s_legal_name: "", //结算人姓名
      s_legal_phone: "", //结算人手机号
      s_legal_id: "", //结算人证件号
      merchant_img_principal_id_card_address: "", //结算人身份证地址
      merchant_t0_rate: "", //T0终端费率
      merchant_t1_rate: "", //T1终端费率
      merchant_d0_rate: "", //D0终端费率
      merchant_unionscan_rate: "", //银联大于1000费率
      merchant_unionscan2_rate: "", //银联小于1000费率
      merchant_union_debit_cap: "", //封顶手续费
      merchant_d1_rate: "", //D1终端费率
      merchant_img_shop_interior: "", //室内照1
      merchant_img_shop_interior_2: "", //室内照2
      merchant_img_shop_interior_3: "", //室内照3
      merchant_img_door_shot: "", //门头照
      merchant_img_door_shot_2: "", //门头照2
      merchant_img_checkout_counter: "", //收银台1
      merchant_img_checkout_counter_2: "", //收银台2
      merchant_img_store_photo: "", //店外景
      location_pic: "", //定位照
      cash_hold_pic: "", //收银台手持身份证照片
      leasing_agreement: "", //租赁协议
      // merchant_img_legal_holding_id_photo_in_door: "", // 法人手持营业执照门口照
      merchant_img_information_form: "", //商户信息表
      merchant_img_agreement: "", //商户收单协议照片
      payCode: "", //支付码
      openid: "", //用户openid
      salesman_id: "", //业务员ID
      current_gangway: "",
      settlement_period: "",
      merchant_img_door_number: "", //门牌号
      mer_area: "",
      mer_area_name: "",
      mcc_name: "",
      store_address: "",
    };

    // console.log("-----", JSON.parse(this.$route.query.form));
    // let query = JSON.parse(this.$route.query.form);
    // this.form.payCode = query.payCode;
    // this.form.current_gangway = query.current_gangway;
    // this.form.settlement_period = query.settlement_period;
    // this.form.mer_area = query.mer_area;
    // this.form.mer_area_name = query.mer_area_name;

    var that = this;
    console.log("------", this.$route.query);
    this.merchant_id = this.$route.query.id * 1;
    this.$http
      .get("/wechat/api.salesman/merchantInfoV2", {
        params: {
          id: this.merchant_id,
        },
      })
      .then((response) => {
        that.form = response.data.data;
        that.provinceCode_cityCode_areaCode =
          response.data.data.stoe_area_cod_name;
        that.merchant_mcc = response.data.data.mcc_name;
        that.fieldValue = that.form.mer_area_name;
        // 结算类型
        if (that.form.settlement_period == "T1") {
          that.settlement_period_text = "T1";
        } else if (that.form.settlement_period == "D1") {
          console.log("010101");
          that.settlement_period_text = "D1";
        } else if (that.form.settlement_period == "D0") {
          console.log("020202");
          that.settlement_period_text = "D0";
        }
        // 结算卡类型
        if (response.data.data.settlement_account_type == "00") {
          that.settlement_account_type_text = "对公账户";
        } else if (response.data.data.settlement_account_type == "01") {
          that.settlement_account_type_text = "对私法人账户";
        } else if (response.data.data.settlement_account_type == "02") {
          that.settlement_account_type_text = "对私非法人账户";
        }
        if (response.data.data.employee_num == 1) {
          that.employee_num = "0-50人";
        } else if (response.data.data.employee_num == 2) {
          that.employee_num = "50-100人";
        } else if (response.data.data.employee_num == 3) {
          that.employee_num = "100以上";
        }

        // 营业执照
        if (response.data.data.merchant_img_electronic_business_license) {
          that.file_img.merchant_img_electronic_business_license.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_electronic_business_license,
          });
        }
        // 法人身份证正
        if (response.data.data.merchant_img_corporate_id_card_front) {
          that.file_img.merchant_img_corporate_id_card_front.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_corporate_id_card_front,
          });
        }
        // 法人身份证反
        if (response.data.data.merchant_img_corporate_id_card_obverse) {
          that.file_img.merchant_img_corporate_id_card_obverse.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_corporate_id_card_obverse,
          });
        }
        // 开户许可证
        if (response.data.data.merchant_img_permit_for_bank_account) {
          that.file_img.merchant_img_permit_for_bank_account.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_permit_for_bank_account,
          });
        }
        // 商户信息表
        if (response.data.data.merchant_img_information_form) {
          that.file_img.merchant_img_information_form.push({
            url:
              Config.baseURL + response.data.data.merchant_img_information_form,
          });
        }
        // 商户协议
        if (response.data.data.merchant_img_agreement) {
          that.file_img.merchant_img_agreement.push({
            url: Config.baseURL + response.data.data.merchant_img_agreement,
          });
        }
        //结算授权书
        if (response.data.data.merchant_img_authorization_statement) {
          that.file_img.merchant_img_authorization_statement.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_authorization_statement,
          });
        }
        // 银行卡正
        if (response.data.data.merchant_img_bank_card) {
          that.file_img.merchant_img_bank_card.push({
            url: Config.baseURL + response.data.data.merchant_img_bank_card,
          });
        }
        // 银行卡反
        if (response.data.data.merchant_img_bank_card_back) {
          that.file_img.merchant_img_bank_card_back.push({
            url:
              Config.baseURL + response.data.data.merchant_img_bank_card_back,
          });
        }
        // 结算人身份证正
        if (response.data.data.merchant_img_principal_id_card_front) {
          that.file_img.merchant_img_principal_id_card_front.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_principal_id_card_front,
          });
        }
        // 结算人身份证反
        if (response.data.data.merchant_img_principal_id_card_obverse) {
          that.file_img.merchant_img_principal_id_card_obverse.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_principal_id_card_obverse,
          });
        }
        //室内照1
        if (response.data.data.merchant_img_shop_interior) {
          that.file_img.merchant_img_shop_interior.push({
            url: Config.baseURL + response.data.data.merchant_img_shop_interior,
          });
        }
        //室内照2
        if (response.data.data.merchant_img_shop_interior_2) {
          that.file_img.merchant_img_shop_interior_2.push({
            url:
              Config.baseURL + response.data.data.merchant_img_shop_interior_2,
          });
        }
        //室内照3
        if (response.data.data.merchant_img_shop_interior_3) {
          that.file_img.merchant_img_shop_interior_3.push({
            url:
              Config.baseURL + response.data.data.merchant_img_shop_interior_3,
          });
        }
        //门头照1
        if (response.data.data.merchant_img_door_shot) {
          that.file_img.merchant_img_door_shot.push({
            url: Config.baseURL + response.data.data.merchant_img_door_shot,
          });
        }
        //门头照2
        if (response.data.data.merchant_img_door_shot_2) {
          that.file_img.merchant_img_door_shot_2.push({
            url: Config.baseURL + response.data.data.merchant_img_door_shot_2,
          });
        }
        //收银照1
        if (response.data.data.merchant_img_checkout_counter) {
          that.file_img.merchant_img_checkout_counter.push({
            url:
              Config.baseURL + response.data.data.merchant_img_checkout_counter,
          });
        }
        //收银照2
        if (response.data.data.merchant_img_checkout_counter_2) {
          that.file_img.merchant_img_checkout_counter_2.push({
            url:
              Config.baseURL +
              response.data.data.merchant_img_checkout_counter_2,
          });
        }
        // 店外景
        if (response.data.data.merchant_img_store_photo) {
          that.file_img.merchant_img_store_photo.push({
            url: Config.baseURL + response.data.data.merchant_img_store_photo,
          });
        }
        // 定位照
        if (response.data.data.location_pic) {
          that.file_img.location_pic.push({
            url: Config.baseURL + response.data.data.location_pic,
          });
        }
        // 收银台手持身份证照片
        if (response.data.data.cash_hold_pic) {
          that.file_img.cash_hold_pic.push({
            url: Config.baseURL + response.data.data.cash_hold_pic,
          });
        }
        // 租赁协议
        if (response.data.data.leasing_agreement) {
          that.file_img.leasing_agreement.push({
            url: Config.baseURL + response.data.data.leasing_agreement,
          });
        }
        // //   法人手持营业照
        // if (response.data.data.merchant_img_legal_holding_id_photo_in_door) {
        //   that.file_img.merchant_img_legal_holding_id_photo_in_door.push({
        //     url:
        //       Config.baseURL +
        //       response.data.data.merchant_img_legal_holding_id_photo_in_door,
        //   });
        // }
        //   门牌号
        if (response.data.data.merchant_img_door_number) {
          that.file_img.merchant_img_door_number.push({
            url: Config.baseURL + response.data.data.merchant_img_door_number,
          });
        }
      });

    if (this.$route.query.code == 0) {
      this.$router.push("/SalesmanLogin");
    }
    if (this.$route.query.salesman_token && this.$route.query.salesman_id) {
      window.localStorage.setItem(
        "salesman_token",
        this.$route.query.salesman_token
      );
      window.localStorage.setItem("salesman_id", this.$route.query.salesman_id);
      window.sessionStorage.setItem("tag", "salesman_log");
      this.form.openid = VueCookie.get("openid"); //用户openid
      this.form.salesman_id = VueCookie.get("salesman_id"); //业务员ID
    }
  },
  methods: {
    // 选择结算类型
    onSettlementPeriodConfirm(val) {
      console.log(val);
      this.settlement_period_text = val.text;
      this.form.settlement_period = val.value;
      this.settlement_period_show_picker = false;
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      console.log("-----", selectedOptions);
      this.form.mer_area = selectedOptions[2].value;
      console.log(this.form.mer_area);
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
      this.form.mer_area_name = selectedOptions
        .map((option) => option.text)
        .join("/");
    },
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/Merchantlist");
    },
    onSubmit() {
      console.log(this.form);

      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      this.$http
        .post("/wechat/api.merchant/updateMerchant", this.form)
        .then(function (response) {
          Toast.clear();
          if (response && response.data.code == 200) {
            Dialog.confirm({
              title: "温馨提示",
              message: "商户信息修改成功！",
            })
              .then(() => {
                this.$router.go(-1);
                // VueCookie.remove("payCode");
                // //跳转首页

                // window.location.href = "/SalesmanHome";
              })
              .catch(() => {
                // on cancel
              });
          } else {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {})
              .catch(() => {});
          }
          // console.log('response', response); this.$route.query.pay_code
        });
    },
    // getAgentRate() {
    //   this.$http.get("/wechat/api.merchant/payAgentInfo").then((response) => {
    //     this.form.merchant_t0_rate = response.body.data.t0_cost;
    //     this.form.merchant_t1_rate = response.body.data.t1_cost;
    //     this.form.merchant_d0_rate = response.body.data.d0_cost;
    //     this.form.merchant_d1_rate = response.body.data.d1_cost;
    //     this.form.merchant_unionscan_rate = response.body.data.unionscan_cost;
    //     this.form.merchant_unionscan2_rate = response.body.data.unionscan2_cost;
    //     this.form.merchant_union_debit_cap =
    //       response.body.data.merchant_union_debit_cap;
    //     this.d0 = response.body.data.d0_cost;
    //     this.d1 = response.body.data.d1_cost;
    //     this.t0 = response.body.data.t0_cost;
    //     this.t1 = response.body.data.t1_cost;
    //     this.unionscan = response.body.data.unionscan_cost;
    //   });
    // },
    //地址选择
    onAddressConfirm(value) {
      console.log("value", value);
      this.provinceCode_cityCode_areaCode = value
        .map((item) => item.name)
        .join("/");
      this.form.store_province = value[0].code;
      this.form.store_city = value[1].code;
      this.form.stoe_area_cod = value[2].code;
      this.show_address_picker = false;
    },
    // mcc码
    merchantMccConfirm(val) {
      console.log(val);
      this.merchant_mcc = val[2];
      this.form.mcc_name = val[2];
      this.form.mcc = val[2].substring(1, 5);
      console.log(this.form.merchant_mcc);
      this.merchant_mcc_picker = false;
    },
    //行业大类
    standardFlagConfirm(val) {
      console.log(val);
      this.standard_flag = val.text;
      this.form.standard_flag = val.value;
      this.standard_flag_picker = false;
    },
    // 公司规模
    employeeNumConfirm(val) {
      console.log(val);
      this.employee_num = val.text;
      this.form.employee_num = val.value;
      this.employee_num_picker = false;
    },
    //选择商户类型
    changeRadio(val) {
      console.log(val);
      //   this.settlement_account_type_text = "";
      // this.form.settlement_account_type = "";
      if (val == 3) {
        this.form.merchant_type == 3;
        this.settlement_account_type_text = "对私法人账户";
        this.form.settlement_account_type = "01";
      }
    },
    //结算类型选中
    onSettlementAccountTypeConfirm(val) {
      console.log(val.value);
      if (val.value == "02") {
        this.rules_merchant_img_permit_for_bank_account = [];
        this.rules_merchant_img_authorization_statement = [
          {
            required: true,
            message: "非法人结算授权书必须上传",
          },
        ];
        this.rules_merchant_img_bank_card = [
          {
            required: true,
            message: "银行卡反面必须上传",
          },
        ];
        this.rules_merchant_img_bank_card_back = [
          {
            required: true,
            message: "银行卡反面必须上传",
          },
        ];
        // this.rules_merchant_img_holding_bank_card = [
        //   {
        //     required: true,
        //     message: "手持银行卡照必须上传",
        //   },
        // ];
      } else if (val.value == "01") {
        this.rules_merchant_img_permit_for_bank_account = [];
        this.rules_merchant_img_authorization_statement = [];
        this.rules_merchant_img_bank_card = [
          {
            required: true,
            message: "银行卡反面必须上传",
          },
        ];
        this.rules_merchant_img_bank_card_back = [
          {
            required: true,
            message: "银行卡反面必须上传",
          },
        ];
        // this.rules_merchant_img_holding_bank_card = [
        //   {
        //     required: true,
        //     message: "手持银行卡照必须上传",
        //   },
        // ];

        this.rules_merchant_img_principal_id_card_front = [];
        this.rules_merchant_img_principal_id_card_obverse = [];
        // this.rules_merchant_img_holding_photo = [];
        this.rules_s_legal_name = [];
        this.rules_s_legal_id = [];
        this.rules_s_legal_start_dt = [];
        this.rules_s_legal_exp_dt = [];
      } else if (val.value == "00") {
        // this.rules_merchant_img_holding_bank_card = [];
        this.rules_merchant_img_bank_card = [];
        this.rules_merchant_img_bank_card_back = [];
        this.rules_merchant_img_authorization_statement = [];
        this.rules_merchant_img_permit_for_bank_account = [
          {
            required: true,
            message: "开户许可证必须上传",
          },
        ];

        this.rules_merchant_img_principal_id_card_front = [];
        this.rules_merchant_img_principal_id_card_obverse = [];
        // this.rules_merchant_img_holding_photo = [];
        this.rules_s_legal_name = [];
        this.rules_s_legal_id = [];
        this.rules_s_legal_start_dt = [];
        this.rules_s_legal_exp_dt = [];
      }
      this.form.settlement_account_type = val.value;
      this.settlement_account_type_text = val.text;
      this.settlement_account_type_show_picker = false;
    },
    //银行网点省
    onProvinceBanksConfirm(value) {
      console.log("value", value);
      this.provinceBanksVal = value;
      this.showProvinceBanksPicker = false;
      this.cityBanksVal = "";
      this.getProvinceBanks(2, value);
    },
    //银行网点市
    onCityBanksConfirm(value) {
      console.log("value", value);
      this.cityBanksVal = value;
      this.showCityBanksPicker = false;
      this.getProvinceBanks(3, value);
    },
    //获取省级别银行网点信息
    getProvinceBanks(level, city = "") {
      this.$http
        .get("/wechat/api.common/getLeshuazfBanks", {
          params: {
            level: level,
            city: city,
          },
        })
        .then(function (response) {
          console.log("response", response);
          switch (level) {
            case 1:
              this.provinceBanks = response.data.data;
              break;
            case 2:
              this.cityBanks = response.data.data;
              break;
            case 3:
              break;
          }
        });
    },
    //银行选中
    banksSelected(col) {
      console.log("col", col);
      this.showBanksPicker = false;
      this.settlement_open_subbank = col.address;
      this.form.settlement_open_subbank = col.address;
      this.form.settlement_bank_code = col.banking;
    },
    //营业执照生效日期
    onBusStartDtConfirm(date) {
      this.form.bus_start_dt = this.formatTime(date);
      this.bus_start_dt_show_picker = false;
    },
    //营业执照失效日期
    onBusExpDtConfirm(date) {
      this.form.bus_exp_dt = this.formatTime(date);
      this.bus_exp_dt_show_picker = false;
    },
    //营业执照失效日期被点击
    bus_exp_dt_show_click() {
      if (!this.isBusExpDt) {
        this.bus_exp_dt_show_picker = true;
      }
    },
    // 控股人身份证有效期
    onControlerLegalConfirm(data) {
      this.form.controler_legal_validity_st = this.formatTime(data);
      this.controler_legal_validity_st_show_picker = false;
    },
    //控股人身份证有效期
    onControlerEnConfirm(data) {
      this.form.controler_legal_validity_en = this.formatTime(data);
      this.controler_legal_validity_en_show_picker = false;
    },
    //控股人身份证失效日期被点击
    controler_legal_validity_en_show_click() {
      if (!this.isControlerEn) {
        this.controler_legal_validity_en_show_picker = true;
      }
    },
    //法人身份证开始日期选择确定
    onCrpStartDtConfirm(date) {
      this.form.crp_start_dt = this.formatTime(date);
      this.crp_start_dt_show_picker = false;
    },
    //法人身份证结束日期选择确定
    onCrpExpDtConfirm(date) {
      this.form.crp_exp_dt = this.formatTime(date);
      this.crp_exp_dt_show_picker = false;
    },
    //法人身份证选择被点击
    crp_exp_dt_show_click() {
      if (!this.isCrpExpDt) {
        this.crp_exp_dt_show_picker = true;
      }
    },
    //结算人身份证失效日期被点击
    s_legal_exp_dt_show_click() {
      if (!this.isSLegalExpDt) {
        this.s_legal_exp_dt_show_picker = true;
      }
    },
    //结算人身份证生效日期
    onSLegalStartDtConfirm(date) {
      this.form.s_legal_start_dt = this.formatTime(date);
      this.s_legal_start_dt_show_picker = false;
    },
    //结算人身份证失效日期
    onSLegalExpDtConfirm(date) {
      this.form.s_legal_exp_dt = this.formatTime(date);
      this.s_legal_exp_dt_show_picker = false;
    },
    //日期格式化
    formatTime(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = date.getDate();
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    },
    //获取微信js
    getWechatJs() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      console.log(this.$store.state);
      let url = this.$store.state.wxSignUrl;
      // let isIos = this.gt_ios4()
      // // let url
      // // console.log(this.$route)
      // if(isIos){
      //        this.iosUrlRefresh(this.$route)
      // }
      // isIos?url = window.location.href.split('#')[0]:url = window.location.href
      // alert(url)
      this.$http
        .post("/wechat/api.common/getWechatJs", {
          url: url,
        })
        .then(function (response) {
          Toast.clear();
          if (response.data && response.data.code == 200) {
            // console.log(JSON.parse(response.data.data));
            // let data = {}
            // Object.assign(data,JSON.parse(response.data.data),{debug:true})
            //  console.log('222222',data)
            // wx.config(data);
            wx.config(JSON.parse(response.data.data));
          }
        });
    },
    gt_ios4() {
      // 判断是否 iPhone 或者 iPod
      if (
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i)
      ) {
        // 判断系统版本号是否大于 4
        return Boolean(
          navigator.userAgent.match(/OS [5-9]_\d[_\d]* like Mac OS X/i)
        );
      } else {
        return false;
      }
    },
    iosUrlRefresh(to) {
      let iosRandom = "iosRandom=" + new Date().getTime(); // 新增随机参数
      let url =
        location.protocol + "//" + location.host + "/mobileTest" + to.fullPath; // 重组url 注意项目路径
      if (url.indexOf("?") > 0) {
        url = url + "&" + iosRandom;
      } else {
        url = url + "?" + iosRandom;
      }
      window.location.replace(url);
    },

    rate(e, v) {
      if (v == "t0") {
        if (e.target.value < this.t0) {
          Notify({
            type: "danger",
            message: "设置费率不能低于默认费率" + this.t0,
          });
          this.form.merchant_t0_rate = this.t0;
        }
      }
      if (v == "t1") {
        if (e.target.value < this.t1) {
          Notify({
            type: "danger",
            message: "设置费率不能低于默认费率" + this.t1,
          });
          this.form.merchant_t1_rate = this.t1;
        }
      }
      if (v == "d0") {
        if (e.target.value < this.d0) {
          Notify({
            type: "danger",
            message: "设置费率不能低于默认费率" + this.d0,
          });
          this.form.merchant_d0_rate = this.d0;
        }
      }
      if (v == "d1") {
        if (e.target.value < this.d1) {
          Notify({
            type: "danger",
            message: "设置费率不能低于默认费率" + this.d1,
          });
          this.form.merchant_d1_rate = this.d1;
        }
      }
      if (v == "unionscan") {
        if (e.target.value < this.unionscan) {
          Notify({
            type: "danger",
            message: "设置费率不能低于默认费率" + this.unionscan,
          });
          this.form.merchant_unionscan_rate = this.unionscan;
        }
      }
    },
    afterRead(file, detail) {
      let that = this;
      console.log("ddddddddddddddddd", detail.name);
      switch (detail.name) {
        case "merchant_img_electronic_business_license":
          that.licensePic = "licensePic";
          break;
        case "merchant_img_corporate_id_card_front":
          that.licensePic = "idcardFrontPic";
          break;
        case "merchant_img_corporate_id_card_obverse":
          that.licensePic = "idcardBackPic";
          break;
        case "merchant_img_bank_card":
          that.licensePic = "bankCardFrontPic";
          break;
        // case 'merchant_img_bank_card_back':
        //     that.licensePic='bankCardFrontPic'
        //     break;
        case "merchant_img_principal_id_card_front":
          that.licensePic = "idcardFrontPic";
          break;
        case "merchant_img_principal_id_card_obverse":
          that.licensePic = "idcardBackPic";
          break;
      }
      this.$http
        .post("/wechat/api.merchant/uploadMerchantImg", {
          localData: file.content,
          openid: window.localStorage.getItem("openid"),
          type: that.licensePic,
        })
        .then((response) => {
          if (response && response.data.code == 200) {
            this.file_img[detail.name][0].url = response.data.url_img;
            this.form[detail.name] = response.data.local_img;
            //设置图片
            that.setImg(detail.name, response);
            if (that.licensePic == "licensePic") {
              that.form.bse_lice_nm = response.data.data.name;
              that.form.bus_lic_no = response.data.data.reg_num;
              that.form.bus_lic_address = response.data.data.address;
              that.form.bus_start_dt =
                response.data.data.establish_date.replace(
                  /^(\d{4})(\d{2})(\d{2})$/,
                  "$1-$2-$3"
                );
            } else if (
              that.licensePic == "idcardFrontPic" &&
              detail.name == "merchant_img_corporate_id_card_front"
            ) {
              that.form.crp_nm = response.data.data.name;
              that.form.crp_id = response.data.data.num;
              that.form.merchant_img_corporate_id_card_address =
                response.data.data.address;
            } else if (
              that.licensePic == "idcardBackPic" &&
              detail.name == "merchant_img_corporate_id_card_obverse"
            ) {
              that.form.crp_start_dt = response.data.data.start_date.replace(
                /^(\d{4})(\d{2})(\d{2})$/,
                "$1-$2-$3"
              );
              if (response.data.data.end_date == "长期") {
                that.form.crp_exp_dt = "9999-12-31";
              } else {
                that.form.crp_exp_dt = response.data.data.end_date.replace(
                  /^(\d{4})(\d{2})(\d{2})$/,
                  "$1-$2-$3"
                );
              }
            } else if (that.licensePic == "bankCardFrontPic") {
              that.form.settlement_card_number = response.data.data.card_num;
              that.form.settlement_bank = response.data.data.bank_name;
            } else if (
              that.licensePic == "idcardFrontPic" &&
              detail.name == "merchant_img_principal_id_card_front"
            ) {
              that.form.s_legal_name = response.data.data.name;
              that.form.s_legal_id = response.data.data.num;
              that.form.merchant_img_principal_id_card_address =
                response.data.data.address;
            } else if (
              that.licensePic == "idcardBackPic" &&
              detail.name == "merchant_img_principal_id_card_obverse"
            ) {
              that.form.s_legal_start_dt =
                response.data.data.start_date.replace(
                  /^(\d{4})(\d{2})(\d{2})$/,
                  "$1-$2-$3"
                );
              if (response.data.data.end_date == "长期") {
                that.form.s_legal_exp_dt = "9999-12-31";
              } else {
                that.form.s_legal_exp_dt = response.data.data.end_date.replace(
                  /^(\d{4})(\d{2})(\d{2})$/,
                  "$1-$2-$3"
                );
              }
            }
          }
        });
    },
    //设置图片
    setImg(field, response) {
      var that = this;
      //图片设置
      switch (field) {
        //法人身份证正面
        case "merchant_img_corporate_id_card_front":
          that.form.merchant_img_corporate_id_card_front =
            response.data.local_img;
          that.img.merchant_img_corporate_id_card_front = response.data.url_img;
          break;
        //法人身份证反面
        case "merchant_img_corporate_id_card_obverse":
          that.form.merchant_img_corporate_id_card_obverse =
            response.data.local_img;
          that.img.merchant_img_corporate_id_card_obverse =
            response.data.url_img;
          break;
        // //手持身份证照
        // case "merchant_img_legal_holding_id_photo":
        //   that.form.merchant_img_legal_holding_id_photo =
        //     response.data.local_img;
        //   that.img.merchant_img_legal_holding_id_photo = response.data.url_img;
        //   break;
        //手持银行卡照正面
        // case "merchant_img_holding_bank_card":
        //   that.form.merchant_img_holding_bank_card = response.data.local_img;
        //   that.img.merchant_img_holding_bank_card = response.data.url_img;
        //   break;
        //手持银行卡照反面
        // case 'merchant_img_holding_bank_card_obverse':
        //     that.form.merchant_img_holding_bank_card_obverse = response.data.local_img;
        //     that.img.merchant_img_holding_bank_card_obverse = response.data.url_img;
        //     break;
        //营业执照
        case "merchant_img_electronic_business_license":
          that.form.merchant_img_electronic_business_license =
            response.data.local_img;
          that.img.merchant_img_electronic_business_license =
            response.data.url_img;
          break;
        //组织机构证
        case "merchant_img_organization":
          that.form.merchant_img_organization = response.data.local_img;
          that.img.merchant_img_organization = response.data.url_img;
          break;
        //税务登记证
        case "merchant_img_tax":
          that.form.merchant_img_tax = response.data.local_img;
          that.img.merchant_img_tax = response.data.url_img;
          break;
        //开户许可证
        case "merchant_img_permit_for_bank_account":
          that.form.merchant_img_permit_for_bank_account =
            response.data.local_img;
          that.img.merchant_img_permit_for_bank_account = response.data.url_img;
          break;
        case "merchant_img_information_form":
          that.form.merchant_img_information_form = response.data.local_img;
          that.img.merchant_img_information_form = response.data.url_img;
          break;
        //商户收单协议照片
        case "merchant_img_agreement":
          that.form.merchant_img_agreement = response.data.local_img;
          that.img.merchant_img_agreement = response.data.url_img;
          break;
        // // 法人手持营业执照门口照
        // case "merchant_img_legal_holding_id_photo_in_door":
        //   that.form.merchant_img_legal_holding_id_photo_in_door =
        //     response.data.local_img;
        //   that.img.merchant_img_legal_holding_id_photo_in_door =
        //     response.data.url_img;
        //   break;
        //门牌号
        case "merchant_img_door_number":
          that.form.merchant_img_door_number = response.data.local_img;
          that.img.merchant_img_door_number = response.data.url_img;
          break;
        //结算授权函
        case "merchant_img_authorization_statement":
          that.form.merchant_img_authorization_statement =
            response.data.local_img;
          that.img.merchant_img_authorization_statement = response.data.url_img;
          break;
        //银行卡正面
        case "merchant_img_bank_card":
          that.form.merchant_img_bank_card = response.data.local_img;
          that.img.merchant_img_bank_card = response.data.url_img;
          break;
        //银行卡反面
        case "merchant_img_bank_card_back":
          that.form.merchant_img_bank_card_back = response.data.local_img;
          that.img.merchant_img_bank_card_back = response.data.url_img;
          break;
        //结算人身份证正面
        case "merchant_img_principal_id_card_front":
          that.form.merchant_img_principal_id_card_front =
            response.data.local_img;
          that.img.merchant_img_principal_id_card_front = response.data.url_img;
          break;
        //结算人身份证反面
        case "merchant_img_principal_id_card_obverse":
          that.form.merchant_img_principal_id_card_obverse =
            response.data.local_img;
          that.img.merchant_img_principal_id_card_obverse =
            response.data.url_img;
          break;
        //结算人手持证件照
        // case "merchant_img_holding_photo":
        //   that.form.merchant_img_holding_photo = response.data.local_img;
        //   that.img.merchant_img_holding_photo = response.data.url_img;
        //   break;
        //室内照
        case "merchant_img_shop_interior":
          that.form.merchant_img_shop_interior = response.data.local_img;
          that.img.merchant_img_shop_interior = response.data.url_img;
          break;
        //室内照2
        case "merchant_img_shop_interior_2":
          that.form.merchant_img_shop_interior_2 = response.data.local_img;
          that.img.merchant_img_shop_interior_2 = response.data.url_img;
          break;
        //室内照3
        case "merchant_img_shop_interior_3":
          that.form.merchant_img_shop_interior_3 = response.data.local_img;
          that.img.merchant_img_shop_interior_3 = response.data.url_img;
          break;
        //门头照
        case "merchant_img_door_shot":
          that.form.merchant_img_door_shot = response.data.local_img;
          that.img.merchant_img_door_shot = response.data.url_img;
          break;
        //门头照2
        case "merchant_img_door_shot_2":
          that.form.merchant_img_door_shot_2 = response.data.local_img;
          that.img.merchant_img_door_shot_2 = response.data.url_img;
          break;
        //收银台1
        case "merchant_img_checkout_counter":
          that.form.merchant_img_checkout_counter = response.data.local_img;
          that.img.merchant_img_checkout_counter = response.data.url_img;
          break;
        //收银台2
        case "merchant_img_checkout_counter_2":
          that.form.merchant_img_checkout_counter_2 = response.data.local_img;
          that.img.merchant_img_checkout_counter_2 = response.data.url_img;
          break;
        //店外景
        case "merchant_img_store_photo":
          that.form.merchant_img_store_photo = response.data.local_img;
          that.img.merchant_img_store_photo = response.data.url_img;
          break;
        // 定位照 location_pic
        case "location_pic":
          that.form.location_pic = response.data.local_img;
          that.img.location_pic = response.data.url_img;
          break;
        // 收银台手持身份证照片  cash_hold_pic
        case "cash_hold_pic":
          that.form.cash_hold_pic = response.data.local_img;
          that.img.cash_hold_pic = response.data.url_img;
          break;
        // 租赁协议  leasing_agreement
        case "leasing_agreement":
          that.form.leasing_agreement = response.data.local_img;
          that.img.leasing_agreement = response.data.url_img;
          break;
        default:
          break;
      }
      this.$forceUpdate();
    },
    //地址拼装
    imgUrl(imgUrl) {
      return Config.baseURL + imgUrl;
    },
    //通用图片上传处理
    openPhoto(field) {
      var that = this;
      var fild = field;
      switch (fild) {
        case "merchant_img_electronic_business_license":
          that.licensePic = "licensePic";
          break;
        case "merchant_img_corporate_id_card_front":
          that.licensePic = "idcardFrontPic";
          break;
        case "merchant_img_corporate_id_card_obverse":
          that.licensePic = "idcardBackPic";
          break;
        case "merchant_img_bank_card":
          that.licensePic = "bankCardFrontPic";
          break;
        // case 'merchant_img_bank_card_back':
        //     that.licensePic='bankCardFrontPic'
        //     break;
        case "merchant_img_principal_id_card_front":
          that.licensePic = "idcardFrontPic";
          break;
        case "merchant_img_principal_id_card_obverse":
          that.licensePic = "idcardBackPic";
          break;
      }
      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ["chooseImage", "getLocalImgData"],
          success: function (res) {
            if (res.checkResult.chooseImage) {
              wx.chooseImage({
                // 默认9
                count: 1,
                // 可以指定是原图还是压缩图，默认二者都有
                sizeType: ["original", "compressed"],
                // 可以指定来源是相册还是相机，默认二者都有
                sourceType: ["album", "camera"],
                success: function (res) {
                  Toast(res);
                  var toast = Toast.loading({
                    duration: 0,
                    message: "处理中",
                    forbidClick: true,
                    loadingType: "spinner",
                  });
                  wx.getLocalImgData({
                    localId: res.localIds[0], // 图片的localID
                    success: function (resData) {
                      var localData = resData.localData;
                      if (localData.indexOf("data:image") != 0) {
                        //判断是否有这样的头部
                        localData = "data:image/jpeg;base64," + localData;
                      }

                      localData = localData
                        .replace(/\r|\n/g, "")
                        .replace("data:image/jgp", "data:image/jpeg");

                      //alert(JSON.stringify(res));
                      //传递数据
                      that.$http
                        .post("/wechat/api.merchant/uploadMerchantImg", {
                          localId: res.localIds[0],
                          type: that.licensePic,
                          localData: localData,
                        })
                        .then((response) => {
                          toast.clear();
                          //设置图片
                          that.setImg(field, response);
                          if (that.licensePic == "licensePic") {
                            that.form.bse_lice_nm = response.data.data.name;
                            that.form.bus_lic_no = response.data.data.reg_num;
                            that.form.bus_lic_address =
                              response.data.data.address;
                            that.form.bus_start_dt =
                              response.data.data.establish_date.replace(
                                /^(\d{4})(\d{2})(\d{2})$/,
                                "$1-$2-$3"
                              );
                          } else if (
                            that.licensePic == "idcardFrontPic" &&
                            field == "merchant_img_corporate_id_card_front"
                          ) {
                            that.form.crp_nm = response.data.data.name;
                            that.form.crp_id = response.data.data.num;
                            that.form.merchant_img_corporate_id_card_address =
                              response.data.data.address;
                          } else if (
                            that.licensePic == "idcardBackPic" &&
                            field == "merchant_img_corporate_id_card_obverse"
                          ) {
                            that.form.crp_start_dt =
                              response.data.data.start_date.replace(
                                /^(\d{4})(\d{2})(\d{2})$/,
                                "$1-$2-$3"
                              );
                            if (response.data.data.end_date == "长期") {
                              that.form.crp_exp_dt = "9999-12-31";
                            } else {
                              that.form.crp_exp_dt =
                                response.data.data.end_date.replace(
                                  /^(\d{4})(\d{2})(\d{2})$/,
                                  "$1-$2-$3"
                                );
                            }
                          } else if (that.licensePic == "bankCardFrontPic") {
                            that.form.settlement_card_number =
                              response.data.data.card_num;
                            that.form.settlement_bank =
                              response.data.data.bank_name;
                          } else if (
                            that.licensePic == "idcardFrontPic" &&
                            field == "merchant_img_principal_id_card_front"
                          ) {
                            that.form.s_legal_name = response.data.data.name;
                            that.form.s_legal_id = response.data.data.num;
                            that.form.merchant_img_principal_id_card_address =
                              response.data.data.address;
                          } else if (
                            that.licensePic == "idcardBackPic" &&
                            field == "merchant_img_principal_id_card_obverse"
                          ) {
                            that.form.s_legal_start_dt =
                              response.data.data.start_date.replace(
                                /^(\d{4})(\d{2})(\d{2})$/,
                                "$1-$2-$3"
                              );
                            if (response.data.data.end_date == "长期") {
                              that.form.s_legal_exp_dt = "9999-12-31";
                            } else {
                              that.form.s_legal_exp_dt =
                                response.data.data.end_date.replace(
                                  /^(\d{4})(\d{2})(\d{2})$/,
                                  "$1-$2-$3"
                                );
                            }
                          }
                        });
                    },
                  });
                },
              });
            }
          },
        });
      });
    },
  },
  watch: {
    //商户类型
    "form.merchant_type": {
      handler: function (age) {
        if (age == "3") {
          this.rules_merchant_img_electronic_business_license = [];
          this.rules_bse_lice_nm = [];
          this.rules_bus_lic_no = [];
          this.rules_bus_lic_address = [];
          this.rules_bus_start_dt = [];
          this.rules_bus_exp_dt = [];
        } else {
          this.rules_merchant_img_electronic_business_license = [
            {
              required: true,
              message: "营业执照必须上传",
            },
          ];
          this.rules_bse_lice_nm = [
            {
              required: true,
              message: "与营业执照上登记注册的名称一致",
            },
          ];
          this.rules_bus_lic_no = [
            {
              required: true,
              message: "营业执照号必须填写",
            },
          ];
          this.rules_bus_lic_address = [
            {
              required: true,
              message: "营业执照地址必须填写",
            },
          ];
          this.rules_bus_start_dt = [
            {
              required: true,
              message: "营业执照生效日期必须填写",
            },
          ];
          this.rules_bus_exp_dt = [
            {
              required: true,
              message: "营业执照失效日期必须填写",
            },
          ];
        }
      },
    },
    //是否营业执照长期
    isBusExpDt(val) {
      if (val) {
        this.form.bus_exp_dt = "9999-12-31";
      } else {
        this.form.bus_exp_dt = "";
      }
    },
    //是否控股人长期
    isControlerEn(val) {
      if (val) {
        this.form.controler_legal_validity_en = "9999-12-31";
      } else {
        this.form.controler_legal_validity_en = "";
      }
    },
    //是否法人身份证结束日期
    isCrpExpDt(val) {
      if (val) {
        this.form.crp_exp_dt = "9999-12-31";
      } else {
        this.form.crp_exp_dt = "";
      }
    },
    //是否结算人身份证结束日期
    isSLegalExpDt(val) {
      if (val) {
        this.form.s_legal_exp_dt = "9999-12-31";
      } else {
        this.form.s_legal_exp_dt = "";
      }
    },
    //银行选择值
    banksValue(val) {
      this.$http
        .get("/wechat/api.common/searchLeshuazfBanks", {
          params: {
            province: this.provinceBanksVal,
            city: this.cityBanksVal,
            banks_text: val,
          },
        })
        .then(function (response) {
          console.log("response", response);
          this.banksData = response.data.data;
        });
    },
    "form.store_contacts": {
      handler: function (vv) {
        if (vv) {
          if (this.form.merchant_type == 3) {
            this.form.crp_nm = vv;
            this.form.settlement_account_name = vv;
            this.form.bse_lice_nm = "商户_" + vv;
          }
        }
      },
    },
    "form.store_tel": {
      handler: function (vv) {
        if (vv) {
          if (this.form.merchant_type == 3) {
            this.form.crp_mobile = vv;
          }
        }
      },
    },
  },
};
</script>
<style scoped>
.checkbox_text {
  font-size: 0.3rem;
}

.van-button {
  margin: 0.2rem 0;
}
.box {
  padding-top: 46px;
}
</style>